import themes from '@bitcoin-portal/bitcoincom-pkg-theme';
import React, { FC, PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './styled';

const { light } = themes;

const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider theme={light}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default Layout;
